import { useTranslation } from "react-i18next";
import { useContext, useEffect, useState } from "react";
import AppContext from "../../context/app/context";
import { useNavigate } from "react-router-dom";
import DonationContext from "../../context/donation/context";
import { useIsMount } from "../../utils/hooks/is-mount";
import styles from "./style.module.scss";
import DonationTable from "../../components/donation/donation-table";
import RefreshBtn from "../../components/general/table-components/actions/refresh-btn";
import { Button, Divider } from "antd";
import Can from "../../utils/rbac/can";
import { CAN_VIEW_HOME_PAGE } from "../../utils/rbac/permissions";
import { PlusOutlined } from "@ant-design/icons";
import PageHeader from "../../components/general/layout/page-header";
import SearchFilterCard from "../../components/general/filter-card";
import DonationContextProvider from "../../context/donation/provider";
import DonationFilter from "../../components/donation/donation-filter";

interface IProps {
    children?: React.ReactNode;
}

const Donation: React.FC<IProps> = () => {
    const { t } = useTranslation();
    const { direction } = useContext(AppContext);
    const navigate = useNavigate();

    const [search, setSearch] = useState<string | undefined>(undefined);
    const { actions, loading, query, list } = useContext(DonationContext);

    useEffect(() => {
        actions.setSearch(search);
    }, [search]);

    const isMounted = useIsMount();
    useEffect(() => {
        !isMounted && actions.getData();
    }, [query, direction]);

    return (
        <div dir={direction} className={styles.container}>
            <PageHeader
                title={t("donations")}
                subTitle={t("donations_manager")}
                extra={[
                    <RefreshBtn
                        key={0}
                        loading={loading.includes("list")}
                        onClick={() => actions.getData()}
                    >
                        {t("refresh")}
                    </RefreshBtn>,
                ]}
            />
            <SearchFilterCard
                formId="donation-filter"
                searchValue={search}
                setSearchValue={setSearch}
                onReset={() => actions.setQuery({
                    page: query?.page,
                    perPage: query?.perPage,
                })}
                resetLoading={loading.includes("list")}
                applyLoading={loading.includes("list")}
            >
                <DonationFilter />
            </SearchFilterCard>
            <DonationTable
                data={list?.data ?? []}
                loading={loading.includes("list")}
                total={list?.total ?? 0}
                page={query.page}
                pageSize={query.perPage}
                onPaginationChange={(page, perPage) => {
                    actions.setQuery({ ...query, page, perPage });
                }}
            />


        </div>
    );
};

const DonationPage = () => {
    return (
        <DonationContextProvider>
            <Donation />
        </DonationContextProvider>
    );
};

export default DonationPage;